export default function Avatar({ user, size = 32, className = "" }) {
  const px = typeof size === "number" ? `${size}px` : size;
  const style = { width: px, height: px };
  if (user?.avatar_url) {
    return (
      <img
        src={user.avatar_url}
        alt={user?.name || ""}
        style={style}
        className={`rounded-full object-cover border border-white/10 shrink-0 ${className}`}
      />
    );
  }
  return (
    <div
      style={style}
      className={`rounded-full lim-gradient grid place-items-center font-display font-semibold text-white shrink-0 ${className}`}
    >
      {user?.name?.[0]?.toUpperCase() || "?"}
    </div>
  );
}
